import { epgLocalTimeStampStorage } from '../../storages';
import { convertWidthToMinutesWidth } from '../../utils';

export const onHandleResize = () =>
  epgLocalTimeStampStorage.setScreenWidthInMinutes(convertWidthToMinutesWidth(document.body.clientWidth));
